import { Avatar, Box, Rating, Table,Paper,TableBody,IconButton,TextField, TableCell, TableContainer, TableHead, TableRow, Typography, Button, Divider } from '@mui/material';
import { deepPurple, orange } from '@mui/material/colors';
import React, { useEffect, useState } from 'react';
import { Add, Delete, Remove } from '@mui/icons-material';
import { BookingService } from '../Service';

const BookingCart = (props) => {
    const {existingCart,onClose} = props;
    // [
    //     {
    //       "id": 1702,
    //       "customerId": 304,
    //       "providerId": 6,
    //       "providerServiceId": 62,
    //       "quantity": 4,
    //       "isActive": true,
    //       "createdAt": "2025-03-11T01:35:51.802Z",
    //       "updatedAt": "2025-03-11T01:35:51.881Z",
    //       "providerServiceCart": {
    //         "id": 62,
    //         "servicesChildId": 623,
    //         "price": "250.00",
    //         "serviceTime": 60,
    //         "childService": {
    //           "id": 623,
    //           "title": "Men's & Kids' Salon Hair Cut",
    //           "images": "hair_cut_beard_styling-1727287384951.png"
    //         }
    //       },
    //       "User": {
    //         "id": 6,
    //         "UserProfile": {
    //           "firstName": "RAVI",
    //           "lastName": "KUMAR",
    //           "profileImage": "null"
    //         }
    //       },
    //       "isActiveservice": true
    //     }
    //   ]
    const [cart, setCart] = useState(existingCart || []);
    useEffect(() => {

    }, [existingCart]);
    const chargeDetails = {
        "additionalCharge": 0,
        "vistingCharge": 100,
        "cancellationChargeInPercent": 10,
        "timeLimitForCancellation": "0",
        "isRefundable": true,
        "refundableAmount": 0,
        "refundableDuration": 0,
        "waiveVisitCharge": "6000.00",
        "minCancellationTime": 3
    }
    const services = [
        {
          "id": 150,
          "serviceTime": 180,
          "price": "1000.00",
          "title": "Regular Service",
          "images": "split_ac_repair-1727287934338.png",
          "charges": {
            "id": 149,
            "vistingCharge": "50.00",
            "additionalCharge": "0.00",
            "cancellationChargeInPercent": 10,
            "timeLimitForCancellation": 3,
            "isRefundable": false,
            "refundableAmount": "0.00",
            "refundableDuration": 0
          },
          "quantity": 2
        },
        {
          "id": 151,
          "serviceTime": 240,
          "price": "1500.00",
          "title": "Advanced Service With Jet",
          "images": "split_ac_repair-1727287935844.png",
          "charges": {
            "id": 150,
            "vistingCharge": "50.00",
            "additionalCharge": "0.00",
            "cancellationChargeInPercent": 10,
            "timeLimitForCancellation": 3,
            "isRefundable": false,
            "refundableAmount": "0.00",
            "refundableDuration": 0
          },
          "quantity": 2
        }
    ]
    const billCalculations = {
        "subTotal": "5000.00",
        "total": 5100,
        "remainingAmounttoWaiveVisitingCharge": 1000
    }
    const handleQuantityChange = (id, quantity) => {

    }
    const handleDeleteService = (id) => {

    }
    
    const [showIndex, setShowIndex] = useState(0);

    // Fetch service data for a specific service ID
    // const fetchServiceData = async (serviceId) => {
    //     try {
    //         const serviceDataResponse = await CrudServices.fetchServiceData(serviceId);
    //         // console.log("serviceDataResponse:",serviceDataResponse);
    //         if (serviceDataResponse.success == '1') {
    //             console.log("serviceDataResponse:",serviceDataResponse);
    //             const rowData = serviceDataResponse.data;
    //             const formattedData = {
    //                 id: rowData?.id,
    //                 categoryId: rowData?.ServiceCategoryRels[0]?.ServiceCategory.parentId,
    //                 subCategoryId: rowData?.ServiceCategoryRels[0]?.serviceCategoryId,
    //                 parentServiceId: rowData.parentServiceId,
    //             };
    //             setServiceData(formattedData);
    //             setBookingInitiationData((prevData) => ({
    //                 ...prevData,
    //                 categoryId: formattedData.categoryId,
    //                 subCategoryId: formattedData.subCategoryId,
    //             }));
    //         }
    //     } catch (error) {
    //         console.error("Error fetching service data:", error);
    //     }
    // };

    const handleCartSelection = (selectedCart)=>{
        console.log("selected cart details:",selectedCart);
        const formattedData = {
            customer:'',
            selected_address:'',
            address:'',
            apartmentRoadArea:'',
            houseFlatBlockNo:'',
            landmark:'',
            city:'',
            latitude:'',
            longitude:'',
            pincode:'',
            state:'',
            categoryId: '',      
            subCategoryId:'',            
            serviceExpert: '',            
            services:[],     
        }
    }
  return (
    <>
        {
            cart.length > 0 && cart.map((item, index) => (
                <Box key={index}>
                    <Box sx={{p:1}}>
                        <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',p:1}}>
                            <Box sx={{display:'flex',alignItems:'center',gap:1}}>
                                <Avatar sx={{ bgcolor: index % 2 === 0 ? deepPurple[500] : orange[500],width:50,height:50,borderRadius:'.5rem' }} variant="square">R</Avatar>
                                <Box>
                                    <Typography sx={{fontSize:'.75rem',fontWeight:600,color:'#3e3e3e'}}>{item?.firstName} {item?.lastName}</Typography>
                                    <Rating name="read-only" value={item?.relatedData[0].User?.UserProfile?.avgRating} readOnly size='small'/>
                                </Box>
                            </Box>
                            <Box sx={{pr:1}}>
                                <Typography sx={{fontSize:'.75rem',fontWeight:600,color:'#3e3e3e'}}>Total Items: {item.relatedData.length}</Typography>
                                <Typography sx={{fontSize:'.75rem',fontWeight:600,color:'#3e3e3e'}}></Typography>
                            </Box>
                            <Button sx={{textTransform:'none'}} size='small' variant='contained' color='info' onClick={()=>onClose( )}>Proceed For New booking</Button>
                            {/* {showIndex === index ?
                                <Button variant='contained' color='primary' size='small' onClick={()=>setShowIndex(null)}>Hide Detail</Button>
                                :
                                <Button variant='contained' color='primary' size='small' onClick={()=>setShowIndex(index)}>View Detail</Button>
                            } */}
                        </Box>
                        {/* { showIndex === index && */}
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{fontWeight:600,p:'1% 2%',fontSize:'.75rem'}} width="40%" >Service</TableCell>
                                            <TableCell sx={{fontWeight:600,p:'1% 2%',fontSize:'.75rem'}} align="center" width="12%">Quantity</TableCell>
                                            <TableCell sx={{fontWeight:600,p:'1% 2%',fontSize:'.75rem'}} align="center" width="12%">Time</TableCell>
                                            <TableCell sx={{fontWeight:600,p:'1% 2%',fontSize:'.75rem'}} align="center" width="12%">Price</TableCell>
                                            <TableCell sx={{fontWeight:600,p:'1% 2%',fontSize:'.75rem'}} align="center" width="12%">Total</TableCell>
                                            {/* <TableCell sx={{fontWeight:600,p:'1% 2%',fontSize:'.75rem'}} align="right" width="12%" >Action</TableCell> */}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {item.relatedData.map((service) => (
                                        <TableRow key={service.id}>
                                            <TableCell sx={{ p: .5,fontSize:'.75rem' }}>{service.providerServiceCart.childService.title}</TableCell>
                                            <TableCell align="center" sx={{ p: .5,fontSize:'.75rem' }}>
                                                {service.quantity}
                                            </TableCell>
                                            <TableCell align="center" sx={{ p: .5,fontSize:'.75rem' }}>
                                                {(service.providerServiceCart.serviceTime)* service.quantity} mins
                                            </TableCell>
                                            <TableCell sx={{ p: .5,fontSize:'.75rem' ,textAlign:'center'}}>₹{service.providerServiceCart.price}</TableCell>                                                                       
                                            <TableCell sx={{ p: .5,fontSize:'.75rem' ,textAlign:'right'}} >₹{parseFloat(service.providerServiceCart.price*service.quantity).toFixed(2)}</TableCell>
                                            {/* <TableCell align="right" sx={{ p: .5,fontSize:'.75rem' }}>
                                                <IconButton
                                                    aria-label="delete"
                                                    onClick={() => handleDeleteService(service.id)}
                                                    size="small"
                                                    color='error'
                                                >
                                                    <Delete sx={{fontSize:'1rem'}}/>
                                                </IconButton>
                                            </TableCell> */}
                                        </TableRow>
                                        ))}
                                        {/* <TableRow sx={{P:0}}>
                                            <TableCell rowSpan={'2'} colSpan={2}/>
                                            <TableCell  sx={{textAlign:'right', fontWeight:'600',borderBottom:'none',p:.5,fontSize:'.75rem'}} colSpan={2}>SubTotal:</TableCell>
                                            <TableCell sx={{textAlign:'right',borderBottom:'none',p:.5,fontSize:'.75rem'}}>₹{billCalculations.subTotal}</TableCell>
                                        </TableRow>
                                        
                                        <TableRow sx={{borderBottom:'1px solid lightGray'}}>
                                        <TableCell  
                                            sx={{
                                            textAlign:'right',
                                            p:.5,fontSize:'.75rem'
                                            }} 
                                            colSpan={2}
                                        >
                                            Visiting Charge:
                                        </TableCell>
                                        <TableCell 
                                            sx={{
                                            textAlign:'right',
                                            p:.5,fontSize:'.75rem'
                                            }}
                                        >
                                            ₹{parseFloat(billCalculations.subTotal)>parseFloat(chargeDetails?.waiveVisitCharge)? parseFloat(0).toFixed(2):parseFloat(chargeDetails?.vistingCharge).toFixed(2)}
                                        </TableCell>
                                        </TableRow>                          
                                        
                                        <TableRow>
                                            <TableCell colSpan={3} sx={{
                                                // textAlign:'right', 
                                                fontWeight:'600',
                                                borderBottom: 'none',p:.5,fontSize:'.75rem'
                                            }}>
                                                <Typography sx={{width:'100%',fontSize:'0.75rem',color:'#3e3e3e'}}>
                                                    {billCalculations.remainingAmounttoWaiveVisitingCharge>0 && `Add more items worth ₹${billCalculations.remainingAmounttoWaiveVisitingCharge} to waive visiting charge`}
                                                </Typography>    
                                            </TableCell>
                                            <TableCell sx={{
                                                textAlign:'right', 
                                                fontWeight:'600',
                                                borderBottom: 'none',p:.5,fontSize:'.75rem'
                                            }}>Total:</TableCell>
                                            <TableCell sx={{
                                                textAlign:'right',
                                                fontWeight:'600',
                                                borderBottom: 'none',p:.5,fontSize:'.75rem'
                                            }}>
                                                ₹{parseFloat(billCalculations.total).toFixed(2)}
                                            </TableCell>
                                        </TableRow> */}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        {/* } */}
                    </Box>
                    <Box sx={{display:'flex',justifyContent:'flex-end',p:1,gap:2}}>
                        <Button sx={{textTransform:'none'}} size='small' variant='contained' color='warning' onClick={()=>handleCartSelection(item)}>Modify & Proceed</Button>
                        {/* <Button sx={{textTransform:'none'}} size='small' variant='contained' color='info' onClick={()=>onClose( )}>New booking</Button> */}
                    </Box> 
                    {index < cart.length - 1 && <Divider sx={{my:'1%',borderColor:'#3a2bde'}}/>}               
                </Box>
            ))

        }
    </>
  );
}

export default BookingCart;
